import React from 'react';

const BadgePill = ({ label, backgroundColor = '#007bff', textColor = '#ffffff' }) => {
  return (
    <span className="badge-pill" style={{ backgroundColor, color: textColor }}>
      {label}
    </span>
  );
};

export default BadgePill;
